// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
logo
*/

.logo {
  line-height: 1;
}

@media (min-width: 1200px) {
  .logo {
    width: 280px;
  }
}

.logo img {
  max-height: 26px;
  margin-right: 6px;
}

.logo span {
  font-size: 26px;
  font-weight: 700;
  color: #012970;
  font-family: "Nunito", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/logo.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC","sourcesContent":["/*\nlogo\n*/\n\n.logo {\n  line-height: 1;\n}\n\n@media (min-width: 1200px) {\n  .logo {\n    width: 280px;\n  }\n}\n\n.logo img {\n  max-height: 26px;\n  margin-right: 6px;\n}\n\n.logo span {\n  font-size: 26px;\n  font-weight: 700;\n  color: #012970;\n  font-family: \"Nunito\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
